import { createRoute } from "@tanstack/react-router";

import { rootRoute } from "@platform/root";
import { LoginPage } from "./login.page";

export const loginRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/login",
	validateSearch: (search: Record<string, unknown>): { redirect?: string; error?: string } => ({
		redirect: typeof search.redirect === "string" ? search.redirect : undefined,
		error: typeof search.error === "string" ? search.error : undefined,
	}),
	component: LoginPage,
});
